import React, { useState } from "react";
import { Link} from 'react-router-dom';
import {
  Button,
  Form,
  Alert,
  Input,

  InputGroupText,
  InputGroup,
  Container,
  Col,
  Row,
  Modal,
  ModalBody
} from "reactstrap";
import API from "api.js";
import Header from "components/Frontend/Header";
import Footer from "components/Frontend/Footer";
import "assets/css/business-page.css"
import HeroSectionUpdated from "components/PublicPagesReusable/HeroSectionUpdated";
import ButtonComp from "components/PublicPagesReusable/ButtonComp";
import ClassImg from "../assets/images/public-pages/class-third.png";
import RealTimeTest from "../assets/images/public-pages/real-time-test.svg"
import DetailedAnalytics from "../assets/images/public-pages/detailed-analytics.svg"
import InstantAccurate from "../assets/images/public-pages/instant-accurate.svg"
import MockTests from "../assets/images/public-pages/mock-tests.svg"
import InDepthFeedback from "../assets/images/public-pages/in-depth-feedback.svg"
import Templates from "../assets/images/public-pages/templates.svg"
import SplitSection from "components/PublicPagesReusable/SplitSection";
import PteDashboardImage from "../assets/images/public-pages/business-image.png"
import FaqSection from "components/PublicPagesReusable/FaqSection";
import CtaBanner from "components/PublicPagesReusable/CtaBanner";
import { grantConsent } from "react-facebook-pixel";

export default function BusinessPage(props) {

	const [instituteForm, setInstituteForm] = useState(false);

	const showHideInstituteRequestForm = (status) => {
		setInstituteForm(status);
	}

	const heroWorkTitle = () => {
    return (
      <h1 className="FS48 fw-500 top-section-text">Power Your Institute With <br />  <span className="text-success"> AI-Driven PTE Training</span> 
          <br />
           
      </h1>
    );
  };

	const heroData = {
    badge: "For PTE Institutes & Training Centres",
    title: heroWorkTitle,
    subtitle: "The white-label platform trusted by 300+ institutes to deliver accurate scoring, unlimited practice, and better student outcomes — all under your brand.",
    btn_prepration: { text: "Register Your Institute", onClick: () => {
    const modal = new window.bootstrap.Modal(document.getElementById('instituteModal'));
    modal.show();
  }},
    btn_outline: { text: "Request Live Demo", variant: "outline", link: '/contact' },
    users: [
      "/images/web-new-images/new-content-slider/User-01.svg",
      "/images/web-new-images/new-content-slider/User-02.svg",
      "/images/web-new-images/new-content-slider/User-03.svg",
      "/images/web-new-images/new-content-slider/RamimRahman-demo.svg",
      "/images/web-new-images/new-content-slider/SapnaPandey-demo.svg",
    ],
    trustText: "Trusted by 50,000+ students'",
    profile: {
      image: "/images/web-new-images/new-content-slider/Business-Container.png",
      stats: [
        
      ]
    },
    bottomStats: [
      { value: "29k",highlight:'+', label: "Practice Questions" },
      { value: "95", highlight:'%', label: "Algorithm Accuracy" },
      { value: "300", highlight:'+', label: "Partners Institutes" },
      { value: "10", highlight:'+', label: "Locations Served" }
    ]
  };

  const extratitle = () => (
  <h2 className="hero-title FS40FW600 mb-3">
                How We Help Your Student<br/> 
                  <span className="text-success FS40FW600"> Perfect Their Score?</span>
              </h2>
)  

  const spliteSectionData = {
	  extratitle : extratitle,
	  gradientBackground : true,
	  quote: "Every PTE aspirant has some goal in their mind. Our site is a curation of several questions by the leading experts. You get a brilliant UI where each section is divided strategically, so students' quickly find what they are looking for. The Portal Is designed to power your students’ preparation with new-age Artificial Intelligence.",
	  descriptions: ["Built on PTE standard algorithms. The technology is quick. Within just a few seconds, evaluates your students' response and gives the corrections, imitating a human-like response, but only quicker and more accurately. The 95% algorithm adoption from the PTE exam ensures that your student gets just 5% more or less marks and score almost as expected.",],
	  buttonText: "Register Now",
	  onButtonClick: () => { const modal = new window.bootstrap.Modal(document.getElementById('staticBackdrop')); modal.show(); },
	  image: PteDashboardImage,
	  bgColor: "#080F1E",
	  textColor: "#ffff",
	  extraOptions : ["Unlimited questions","Unlimited mock tests","Access templates","Accurate the score card","In-Depth Feedback" , "Success Plan","Progress Tracking","Instant Results","Real-Time Performance","& Much More"]
	};

	const faqQuestions = [
    {
      question: "What is the recommended number of PTE mock tests that I should undertake?",
      answer: "It is recommended to take three complete PTE mock tests."
    },
    {
      question: "What is the PTE requirement for canada?",
      answer: "The minimum PTE score for Bachelor's programs, Advanced Diplomas, and Post Graduate Programs is 60, with a minimum band score of 53. Students with an overall score of 56 and each band score of at least 51 have also been granted study permits."
    },
    {
      question: "What is the duration of a full-length PTE mock test?",
      answer: "Around 2 hours. Students can attempt the test in one go or by taking short breaks."
    },
  ];
  

	return (
		<React.Fragment>
			<div className="new-design">
  
			<Header />
			    <HeroSectionUpdated data={heroData} isTrustedShow={false} isBigImage={true} />
                <div className="custom-container py-5 mt-5">
					<div className="custom-container py-5 mt-5">
								{/* Top: Title left + Description & CTA right */}
								<div className="d-flex flex-wrap justify-content-between align-items-start mb-5 gap-4">
								  <h2 className="top-section-text FS40FW600 mb-0">
									Built For <span className="green-text"><em>Excellence</em></span><br />
									
								  </h2>
								  <div className="d-flex flex-column align-items-start gap-4" style={{ maxWidth: '520px' }}>
									<p className="plus-sans FS16FW500 mb-0" style={{ color: '#0D1830' }}>
									  Empower your institute with us!
									</p>
									<ButtonComp btnText="Register Now" link={() => {
    const modal = new window.bootstrap.Modal(document.getElementById('instituteModal'));
    modal.show();
  }}  />
								  </div>
								</div>
					
								{/* Bottom: Left list + Center image + Right list */}
							<div className="row g-4 align-items-center">
																 {/* Left column - 2 items */}
							<div className="col-lg-4">
								<div className="d-flex flex-column gap-4">
								    {[
								   { title: "Real-Time Test Environment", image: RealTimeTest },
							     { title: "Detailed Analytics", image: DetailedAnalytics  },
								 { title: "Instant and Accurate Evaluation", image: InstantAccurate  },
					             ].map((item, i) => (
							   <div key={i} className="bg-white p-4 rounded-4 border shadow-sm h-100" style={{ borderColor: 'rgba(0,0,0,0.05)' }}>
								<img src={item.image} alt="tick" className="mb-3" style={{ width: '52px', height: '52px' }} />
								<h4 className="plus-sans fw-700 mb-2" style={{ fontSize: '22px', color: '#141414' }}>{item.title}</h4>
								</div>
								))}
								 </div>
							</div>
												   
						{/* Center - Image */}
						    <div className="col-lg-4">
								<img
								 src={ClassImg}
								 alt="Success Pathways"
								className="w-100 rounded-5"
								 style={{ height: '560px', objectFit: 'cover', border: '1px solid rgba(0,0,0,0.05)' }}
								 />
								</div>
												   
								{/* Right column - 2 items */}
								<div className="col-lg-4">
								<div className="d-flex flex-column gap-4">
								{[
							    { title: "Mock Tests", image: MockTests },
								 { title: "In-Depth Feedback", image: InDepthFeedback },
								 { title: "Templates", image: Templates },
								 ].map((item, i) => (
							    <div key={i} className="bg-white p-4 rounded-4 border shadow-sm h-100" style={{ borderColor: 'rgba(0,0,0,0.05)' }}>
							   <img src={item.image} alt="tick" className="mb-3" style={{ width: '52px', height: '52px' }} />
								<h4 className="plus-sans fw-700 mb-2" style={{ fontSize: '22px', color: '#141414' }}>{item.title}</h4>
								 </div>
								))}
								 </div>
							   </div>
							</div>
						</div>
				</div>

				<div className="custom-container py-2">
					<div className="d-flex flex-wrap justify-content-between align-items-end mb-5 gap-4">
						<h2 className="FS40FW600 mb-0" style={{ color: '#0D1830' }}>
							From Sign Up to <br />
							<span style={{ fontFamily: "'Tropiline', sans-serif", fontStyle: 'italic', color: '#94C23C' }}>
								Live in 48 Hours
							</span>
						</h2>
						<div className="d-flex flex-column align-items-end text-lg-end" style={{ maxWidth: '400px' }}>
							<p className="plus-sans FS16FW500 mb-0 text-start" style={{ color: '#0D1830' , fontWeight:"300" }}>
								No technical setup required. We handle everything so you can focus on teaching.
							</p>
						</div>
					</div>

					<div className="row g-4">
						{[
							{ 
								num: "01", 
								title: "Register", 
								desc: "Fill out a short form. We'll contact you within 24 hours to understand your needs.",
								
							},
							{ 
								num: "02", 
								title: "Onboard", 
								desc: "We set up your admin portal, import your student list, and configure your branding." 
							},
							{ 
								num: "03", 
								title: "Train Students'", 
								desc: "Give students' access to the platform. Full training materials and support included." 
							},
							{ 
								num: "04", 
								title: "Track Results", 
								desc: "Monitor progress, celebrate wins, and iterate on what works for your cohorts.",
								
							},
						].map((item, i) => (
							<div key={i} className="col-lg-3 col-md-6">
								<div className="bg-white p-4 rounded-4 border shadow-sm h-100 position-relative" style={{ borderColor: 'rgba(0,0,0,0.05)' }}>
									<div className="FS48 fw-700 mb-3" style={{ color: '#94C23C', opacity: 0.5 }}>{item.num}</div>
									<h4 className="plus-sans fw-700 mb-3" style={{ fontSize: '24px', color: '#141414' }}>{item.title}</h4>
									<p className="plus-sans FS16FW500 mb-0" style={{ color: '#383838', lineHeight: '1.6' }}>{item.desc}</p>
									
								</div>
							</div>
						))}
					</div>
				</div>

				<SplitSection {...spliteSectionData} btnImg="/images/web-new-images/new-dark-arrow.svg"/>
                
				<div className="mt-5">
				<FaqSection questions={faqQuestions}/>

				<div style={{ padding: "40px 0 30px 0" }}>
                           <CtaBanner
                             title="Ready to Achieve Your "
                             highlight="Target Score?"
                             buttonText="Book Free Consultation"
                             onClick={() => { const modal = new window.bootstrap.Modal(document.getElementById('staticBackdrop')); modal.show(); }}
                             rightImage="/images/web-new-images/HomePageImage/CTA-Image.webp"
                             btnText="See Our Programs"
                             subTitle={"Join the thousands of students' who've transformed their futures with Language Academy. Don't let another failed attempt delay your dreams."}
                           />
                         </div>				
				</div>
			<Footer />
			<InstituteForm instituteForm={instituteForm} closeForm={showHideInstituteRequestForm} />
			</div>
		</React.Fragment>
	);
}


const InstituteForm = ({ instituteForm, closeForm }) => {

	const [taskName, setTaskName] = useState("");
	const [taskPhone, setTaskPhone] = useState("");
	const [taskEmail, setTaskEmail] = useState("");
	const [taskInstitute, setTaskInstitute] = useState("");
	const [errorMessage, setErrorMessage] = useState("");
	const [successMessage, setSuccessMessage] = useState("");

	const updateMessages = (type, message) => {
		switch(type) {
			case "error":
				setSuccessMessage("");
				setErrorMessage(message);
				break;
			case "success":
				setErrorMessage("");
				setSuccessMessage(message);
				break;
		}
	}

	const post20taskRequest = async (e) => {
		e.preventDefault();
		if(taskName === '' || taskPhone === '' || taskEmail === '' || taskInstitute === '') {
			updateMessages("error", "Please fill all fields!");
		} else {
			const bodyFormData = new FormData();
			bodyFormData.set('name', taskName);
			bodyFormData.set('phone', taskPhone);
			bodyFormData.set('email', taskEmail);
			bodyFormData.set('institute', taskInstitute);
			
			let res = null;
			try {
				res = await API({
					method: 'POST',
					url: '/task-request-submit-data',
					data: bodyFormData
				});
			} catch(error) {};

			if (res.status === 200) {
				updateMessages("success", "Request Submitted Successfully!");
				setTimeout(function() {
					window.location.reload();
				}, 2000);
			} else {
				updateMessages("error", "Unable to submit request!");
			}
		}
	}

	return (
		<Modal isOpen={instituteForm} id="anouncementPopup" size="lg" className="taskpopup">
			<ModalBody>
				<Container>
					<Row>
						<Col className="ml-auto mr-auto" lg="12" md="12">
							<button onClick={ (e) => { closeForm(false) }} type="button" className="close" data-dismiss="modal">&times;</button>
							<div className="mobileIcon">
								<img src="/images/experienced-trainer.png" alt="mobile-img" />
							</div>
							<Form action="" className="form" method="">
								<h3 className="header text-center">Get our portal for your institute</h3>
								
								{successMessage !== "" && 
									<Alert color="success">{successMessage}</Alert>
								}
								{errorMessage !== "" && 
									<Alert color="danger">{errorMessage}</Alert>
								}

								<InputGroup>
									<InputGroupText>
										<i className="nc-icon nc-single-02" />
									</InputGroupText>
									<Input
										placeholder="Name"
										type="text"
										name="task_name"
										value={taskName}
										onChange={(e) => { setTaskName(e.target.value)} }
										autoComplete="off"
									/>
								</InputGroup>
								<InputGroup>
									<InputGroupText>
										<i className="nc-icon nc-mobile" />
									</InputGroupText>
									<Input
										placeholder="Phone"
										type="number"
										name="task_phone"
										value={taskPhone}
										onChange={(e) => { setTaskPhone(e.target.value)} }
										autoComplete="off"
									/>
								</InputGroup>
								<InputGroup>
									<InputGroupText>
										<i className="nc-icon nc-email-85" />
									</InputGroupText>
									<Input
										placeholder="Email"
										type="text"
										name="task_email"
										value={taskEmail}
										onChange={(e) => { setTaskEmail(e.target.value)} }
										autoComplete="off"
									/>
								</InputGroup>
								<InputGroup>
									<InputGroupText>
										<i className="nc-icon nc-badge" />
									</InputGroupText>
									<Input
										placeholder="Institute Name"
										type="text"
										name="task_institute"
										value={taskInstitute}
										onChange={(e) => { setTaskInstitute(e.target.value)} }
										autoComplete="off"
									/>
								</InputGroup>
								<br />
								<Button
									className="btn-round mb-3"
									color="warning"
									onClick={(e) => { post20taskRequest(e) }}
								>Submit</Button>
							</Form>
						</Col>
					</Row>
				</Container>
			</ModalBody>
		</Modal>
	);
}